import { useNewCode } from '@calendly/feature-check-react'
import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const CRM_IMPORT_FORMS_FLAG_KEY = 'crm_import_forms_feature'
const CONTACT_IMPORT_RESUME_PARAM = 'contact_import_entry'
const DEFAULT_IMPORT_ENTRY_POINT = 'file'

export const useImportContactsModalState = () => {
  const history = useHistory()
  const location = useLocation()
  const importFormsFlag = useNewCode(CRM_IMPORT_FORMS_FLAG_KEY)
  const isGoogleFormsEnabled = importFormsFlag?.enabled ?? false
  const [importEntryPoint, setImportEntryPoint] = useState(null)

  const clearResumeParam = useCallback(() => {
    const params = new URLSearchParams(location.search)

    if (!params.has(CONTACT_IMPORT_RESUME_PARAM)) {
      return
    }

    params.delete(CONTACT_IMPORT_RESUME_PARAM)

    const search = params.toString()
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : '',
      hash: location.hash,
    })
  }, [history, location.hash, location.pathname, location.search])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const resumedEntryPoint = params.get(CONTACT_IMPORT_RESUME_PARAM)

    if (!resumedEntryPoint) {
      return
    }

    if (resumedEntryPoint === 'typeform') {
      setImportEntryPoint('typeform')
      clearResumeParam()
      return
    }

    if (resumedEntryPoint === 'google_forms') {
      if (typeof importFormsFlag?.enabled === 'undefined') {
        return
      }

      if (isGoogleFormsEnabled) {
        setImportEntryPoint('google_forms')
      }
    }

    clearResumeParam()
  }, [clearResumeParam, importFormsFlag?.enabled, isGoogleFormsEnabled, location.search])

  const openImportModal = useCallback(({ importEntryPoint: nextEntryPoint = DEFAULT_IMPORT_ENTRY_POINT } = {}) => {
    setImportEntryPoint(nextEntryPoint)
  }, [])

  const closeImportModal = useCallback(() => {
    setImportEntryPoint(null)
  }, [])

  return {
    importEntryPoint,
    isImportModalOpen: importEntryPoint !== null,
    openImportModal,
    closeImportModal,
  }
}
